import React from "react";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";

const carTypes = [
  { value: "folksbill", label: "Fólksbíll" },
  { value: "jeppi", label: "Jeppi" },
  { value: "jepplingur", label: "Jepplingur" },
  { value: "yfirstaerd", label: "Yfirstærð" },
];

const CarForm = ({
  carNumber,
  carSize,
  carMake,
  carType,
  carColor,
  handleCarSelection,
  handleSizeSelection,
  handleMakeSelection,
  handleTypeSelection,
  handleColorSelection,
  carValidation,
  error,
  step,
  helperText,
  submitFunction,
  specialNumber,
  toggleSpecialNumber,
}) => (
  <form className="mainForm" onSubmit={submitFunction}>
    <h2>Upplýsingar um bílinn</h2>
    {step}
    <TextField
      autoFocus
      label="Bílnúmer"
      placeholder="AB12345"
      margin="normal"
      maxLength="5"
      value={carNumber}
      onChange={(e) => handleCarSelection(e.target.value)}
      className="mainInput"
      helperText={helperText}
      tabIndex={1}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <p
              className="disableCarnumber"
              onClick={(e) => toggleSpecialNumber()}
              style={{
                fontWeight: 900,
                cursor: "pointer",
                color: specialNumber ? "#015351" : "#dcdcdc",
              }}
            >
              Einkanúmer{!specialNumber && "?"}
            </p>
            {/* <IconButton
                            aria-label="Ekki með bílnúmerið hjá þér? ( eða einkanúmer )"
                            onClick={e => handleCarSelection('XXXXX')}
                        >
                            ekki með númer?
                        </IconButton> */}
          </InputAdornment>
        ),
      }}
    />
    <TextField
      select
      label="Stærðarflokkur"
      className="mainInput"
      value={carSize}
      onChange={(e) => handleSizeSelection(e.target.value)}
      helperText={!carSize ? "Veldu stærðina sem þinn bíll tilheyrir" : ""}
      margin="normal"
      tabIndex={2}
    >
      {carTypes.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
    {(error || specialNumber) && (
      <div className="additionDetails">
        <TextField
          autoFocus
          label="Tegund"
          placeholder="Skoda"
          margin="normal"
          maxLength="5"
          value={carMake}
          onChange={(e) => handleMakeSelection(e.target.value)}
          className="mainInput"
          tabIndex={1}
        />
        <TextField
          label="Undirtegund"
          placeholder="octavia"
          margin="normal"
          maxLength="5"
          value={carType}
          onChange={(e) => handleTypeSelection(e.target.value)}
          className="mainInput"
          tabIndex={2}
        />
        <TextField
          label="Litur"
          placeholder="blár"
          margin="normal"
          maxLength="5"
          value={carColor}
          onChange={(e) => handleColorSelection(e.target.value)}
          className="mainInput"
          tabIndex={3}
        />
      </div>
    )}
    <Button
      variant="contained"
      className={"mainButton"}
      type="submit"
      disabled={!carValidation}
    >
      Halda áfram
    </Button>
  </form>
);

export default CarForm;



// WEBPACK FOOTER //
// ./src/components/ui/Forms/CarForm.js